import { propertyQueryKeys as e } from "../properties/usePropertiesQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { roomsApi as n } from "@maat/api-main";
//#region src/rooms/useRoomDetailQuery.ts
var r = 20, i = (i, a = r) => t({
	queryKey: e.room(i, a),
	queryFn: () => n.getRoom(i, { events_limit: a }),
	enabled: !!i
});
//#endregion
export { i as useRoomDetailQuery };
